import { localDate } from '@/platform/lib/utils';
import { Button, Header } from '@/platform/ui';
import { QueueListIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';
import { useState } from 'react';
import EmployeeTimelinePanel from './EmployeeTimelinePanel';

const BaseEmployeeInfo = () => {
    const { base_employee: employee } = usePage().props;

    const [showTimeline, setShowTimeline] = useState(false);

    return (
        <div className='mb-8 flex flex-col justify-between border-b border-gray-300 pb-4 sm:flex-row'>
            <div className='flex items-center justify-center gap-4 sm:justify-start'>
                <Header as='h2' className='text-primary-500'>
                    {employee.bsn}
                </Header>
                <div>
                    <Header
                        subheader={`${employee?.customer?.name || ''} | ${employee?.entity?.name || ''}`}
                        as='h3'
                    >
                        {`${employee.name} (${localDate(employee.birth_date)})`}
                    </Header>
                </div>
            </div>
            <div className='mt-4 flex items-center justify-between gap-4'>
                <Button
                    type='button'
                    aria-label='Tijdlijn bekijken'
                    onClick={() => setShowTimeline(true)}
                >
                    <QueueListIcon className='size-4' />
                </Button>
            </div>

            {showTimeline && (
                <EmployeeTimelinePanel onClose={() => setShowTimeline(false)} />
            )}
        </div>
    );
};

export default BaseEmployeeInfo;
